import React from "react";
import Layout from "./Layout";
import { Toaster } from "react-hot-toast";

const App = () => {
  return (
    <div className="App">
      <Layout />
      <Toaster />
    </div>
  );
};

export default App;
